import api from '@/js/services/api';

export default {

    //get
    getAdminType() {
        return api().get(`/admin/type/get`);
    },

    getListOfArtists(filters) {
        const searchParams = new URLSearchParams();
        for( const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get(`/admin/artists/get?` + searchParams.toString())
    },

    getListOfCategories() {
        return api().get(`/admin/categories/get`);
    },

    getListOfCompanies() {
        return api().get(`/admin/companies/get`);
    },

    getCategoryDetails(category_id) {
        return api().get(`/admin/categories/${category_id}/get`);
    },

    getCompanyDetails(company_id) {
        return api().get(`/admin/company/${company_id}/get`);
    },

    getSubcategoriesForSelect() {
        return api().get(`/admin/artist/subcategories/get`);
    },

    getRegistrationLink(type) {
        return api().get(`/admin/registration-link/generate?type=${type}`);
    },

    getArtistInfo(artist_id) {
        return api().get(`/admin/artist/${artist_id}/get`);
    },

    getUsersList() {
        return api().get(`/admin/users/get`);
    },

    getRolesList() {
        return api().get(`/admin/types/get`);
    },

    getUserInfo(user_id) {
        return api().get(`/admin/user/${user_id}/get`);
    },

    getClientsList(filters) {
        const searchParams = new URLSearchParams();
        for( const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get(`/admin/clients/get?` + searchParams.toString())
    },

    getClientInfo(client_id) {
        return api().get(`/admin/client/${client_id}/get`);
    },


    //put

    updateClientStatus(client_id, status) {
        return api().put(`/admin/client/${client_id}/status/update`, {status});
    },

    updateCategoryInfo(category_id, data) {
        return api().put(`/admin/category/${category_id}/update`, data);
    },

    updateCompanyStatus(company_id) {
        return api().put(`/admin/company/${company_id}/status/update`);
    },

    updateCategoryStatus(category_id) {
        return api().put(`/admin/category/${category_id}/status/update`);
    },

    updateCompanyDetails(company_id, data) {
        return api().put(`/admin/company/${company_id}/update`, data);
    },

    updateArtistStatus(artist_id, status) {
        return api().put(`/admin/artist/${artist_id}/status/update`, {status});
    },

    updateArtistFeatured(artist_id, featured) {
        return api().put(`/admin/artist/${artist_id}/featured/update`, {featured});
    },

    updateUserInfo(user_id, data ) {
        return api().put(`/admin/user/${user_id}/update`, data);
    },



    //post
    updateCompaniesOrder(companies) {
        return api().post(`/admin/companies/sort`, {companies});
    },

    createNewCategory(data) {
        return api().post(`/admin/category/create`, data);
    },

    uploadCategoryCover(formData) {
        return api().post(`/admin/category/photo/upload`, formData);
    },

    uploadCompanyCover(formData) {
        return api().post(`/admin/company/photo/upload`, formData);
    },

    updateCategoriesOrder(categories) {
        return api().post(`/admin/categories/sort`, {categories});
    },

    createNewCompany(data) {
        return api().post(`/admin/company/create`, data);
    },

    createNewUser(data) {
        return api().post(`/admin/user/create`, data);
    },

    updateUsersOrder(users) {
        return api().post(`/admin/users/sort`, {users});
    },

    saveLinksForVideo(artist_id, links) {
        return api().post(`/artist/${artist_id}/video/links/store`, links);
    },

    // delete

    deleteArtist(artist_id) {
        return api().delete(`/artist/${artist_id}/delete`);
    },

    deleteUser(user_id) {
        return api().delete(`/admin/user/${user_id}/delete`);
    },

    deleteClient(client_id) {
        return api().delete(`/admin/client/${client_id}/delete`);
    }

}
